import { render, staticRenderFns } from "./EmployeesGroupSelectWorkTypeExtraTable.vue?vue&type=template&id=0b3db19c&"
import script from "./EmployeesGroupSelectWorkTypeExtraTable.vue?vue&type=script&lang=js&"
export * from "./EmployeesGroupSelectWorkTypeExtraTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports